const buttonFocus = 'peer-focus:outline peer-focus:outline-2 peer-focus:outline-offset-2 peer-focus:outline-indigo-600'
const standardButton = 'btn btn-primary hover:cursor-pointer ml-6 text-white whitespace-nowrap'
export const buttonClass = [standardButton, buttonFocus].join(' ')
